
export function getToken(name) {
  // return localStorage.getItem(name)
  return get(name)
}

export function setToken(name, token) {
  // localStorage.setItem(name, token)
  set(name,token)
}

export function removeToken(name) {
  localStorage.removeItem(name)
}

export function removeAll() {
  localStorage.clear()
}


// 设置过期 时间
function set(key, value) {
  let curTime = new Date().getTime()
  localStorage.setItem(key, JSON.stringify({ data: value, time: curTime }))
}

function get(key) {
  let exp = 1000 * 60 * 60 * 60

  let data = localStorage.getItem(key)
  let dataObj = JSON.parse(data)
  if(!dataObj){
    return null
  }
  if (new Date().getTime() - dataObj.time > exp) {
    return null
  } else {
    return  dataObj.data
  }
}




// WEBPACK FOOTER //
// ./src/utils/localstorage.js